module.exports = __webpack_public_path__ + "static/TabsVerticalBar-903d3845edff1f673f64ab0bdafc6e35.png";